import { CacheKey } from "@/modules/cache/constants";
import { GLOBAL_CACHE_INSTANCE } from "@/modules/cache/globalCache";

export const setMetricsSegmentAnonymousId = async ({
  segmentAnonymousId,
}: {
  segmentAnonymousId: string;
}) => {
  await GLOBAL_CACHE_INSTANCE.set(CacheKey.MetricsSegmentAnonymousId, { segmentAnonymousId });
};

export const getMetricsSegmentAnonymousId = async (): Promise<{
  segmentAnonymousId: string | null;
}> => {
  const cachedData = await GLOBAL_CACHE_INSTANCE.get(CacheKey.MetricsSegmentAnonymousId, {
    keepInTabMemory: true,
  });

  if (cachedData) {
    return { segmentAnonymousId: cachedData?.segmentAnonymousId ?? null };
  }

  /**
   * If cached data isn't set, we just return null.
   *
   * This value should only be used for:
   * - `segmentAnalyticsInstance().setAnonymousId(...)` logic, which carries over
   *   the anonymous ID from the browser to the Desktop app.
   *
   * If not set, segment will automatically grab the value from the browser.
   * (So we don't need to "override" it manually with the same browser value, as that would be redundant.)
   */
  return { segmentAnonymousId: null };
};

export const clearMetricsSegmentAnonymousId = async () => {
  await GLOBAL_CACHE_INSTANCE.del(CacheKey.MetricsSegmentAnonymousId);
};
